export const PROCESS_STATUS = Object.freeze({
  PENDING: 'PENDING',
  ACTIVE: 'ACTIVE',
  FINISH: 'FINISH',
  CANCELLED: 'CANCELLED',
  INVOICED: 'INVOICED'
})

export const SERVICE_STATUS = Object.freeze({
  APPROVED: 'APPROVED',
  NOT_APPROVED: 'NOT_APPROVED',
  PENDING: 'PENDING',
  ASSIGNED: 'ASSIGNED',
  IN_PROGRESS: 'IN_PROGRESS',
  CANCELLED: 'CANCELLED'
})

export const processStatusVal = Object.freeze([
  {
    text: 'Pendiente',
    value: 'PENDING'
  },
  {
    text: 'Activo',
    value: 'ACTIVE'
  },
  {
    text: 'Finalizado',
    value: 'FINISH'
  },
  {
    text: 'Cancelado',
    value: 'CANCELLED'
  }
])

export const servicesStatusVal = Object.freeze([
  {
    text: 'Favorable',
    value: SERVICE_STATUS.APPROVED
  },
  {
    text: 'No Favorable',
    value: SERVICE_STATUS.NOT_APPROVED
  },
  {
    text: 'En Progreso',
    value: SERVICE_STATUS.IN_PROGRESS
  },
  {
    text: 'Cancelado',
    value: SERVICE_STATUS.CANCELLED
  }
])

export const TASK_STATUS = Object.freeze({
  PLANNED: 'PLANNED',
  IN_PROGRESS: 'IN_PROGRESS',
  EXECUTED: 'EXECUTED'
})

export const taskStatusVal = Object.freeze([
  {
    text: 'Planeado',
    value: TASK_STATUS.PLANNED
  },
  {
    text: 'En Progreso',
    value: TASK_STATUS.IN_PROGRESS
  },
  {
    text: 'Ejecutado',
    value: TASK_STATUS.EXECUTED
  }
])

export const REPORT_STATUS = Object.freeze({
  NONE: 'NONE',
  PENDING_APPROVAL: 'PENDING_APPROVAL',
  APPROVED: 'APPROVED',
  REJECTED: 'REJECTED'
})

// Badge del estado de aprobación del cliente (XAN-130). NONE no se muestra.
export const reportStatusVal = Object.freeze([
  {
    text: 'Esperando aprobación',
    value: REPORT_STATUS.PENDING_APPROVAL,
    color: 'warning'
  },
  {
    text: 'Aprobado por el cliente',
    value: REPORT_STATUS.APPROVED,
    color: 'success'
  },
  {
    text: 'Rechazado por el cliente',
    value: REPORT_STATUS.REJECTED,
    color: 'error'
  }
])

// XAN-24 — gestor de tickets internos (estilo Linear).
export const TICKET_STATUS = Object.freeze({
  BACKLOG: 'BACKLOG',
  TODO: 'TODO',
  IN_PROGRESS: 'IN_PROGRESS',
  DONE: 'DONE',
  CANCELLED: 'CANCELLED'
})

export const TICKET_PRIORITY = Object.freeze({
  NO_PRIORITY: 'NO_PRIORITY',
  URGENT: 'URGENT',
  HIGH: 'HIGH',
  MEDIUM: 'MEDIUM',
  LOW: 'LOW'
})

// Orden = orden de columnas del tablero.
export const ticketStatusVal = Object.freeze([
  {
    text: 'Backlog',
    value: TICKET_STATUS.BACKLOG,
    color: 'grey'
  },
  {
    text: 'Por hacer',
    value: TICKET_STATUS.TODO,
    color: 'blue-grey'
  },
  {
    text: 'En progreso',
    value: TICKET_STATUS.IN_PROGRESS,
    color: 'orange darken-1'
  },
  {
    text: 'Completado',
    value: TICKET_STATUS.DONE,
    color: 'green darken-1'
  },
  {
    text: 'Cancelado',
    value: TICKET_STATUS.CANCELLED,
    color: 'red darken-1'
  }
])

// Íconos estilo Linear: barras ascendentes para Alta/Media/Baja (mismo lenguaje visual que usa
// Linear para prioridad), alerta para Urgente, barras vacías para Sin prioridad.
export const ticketPriorityVal = Object.freeze([
  {
    text: 'Sin prioridad',
    value: TICKET_PRIORITY.NO_PRIORITY,
    color: 'grey lighten-1',
    icon: 'mdi-signal-cellular-outline'
  },
  {
    text: 'Urgente',
    value: TICKET_PRIORITY.URGENT,
    color: 'red darken-2',
    icon: 'mdi-signal-cellular-3'
  },
  {
    text: 'Alta',
    value: TICKET_PRIORITY.HIGH,
    color: 'orange darken-1',
    icon: 'mdi-signal-cellular-3'
  },
  {
    text: 'Media',
    value: TICKET_PRIORITY.MEDIUM,
    color: 'amber darken-3',
    icon: 'mdi-signal-cellular-2'
  },
  {
    text: 'Baja',
    value: TICKET_PRIORITY.LOW,
    color: 'blue-grey lighten-1',
    icon: 'mdi-signal-cellular-1'
  }
])

// Viáticos are paid only to whoever did the in-person visit. Visita Virtual is left out on
// purpose: nobody travels. Must match VISIT_SERVICE_IDS in risk-shield-api.
export const VISIT_SERVICE_IDS = Object.freeze([
  '832bd8a2-1313-4e8c-bb78-45ef269e9665', // Visita Domiciliaria
  'b3fb76f3-9164-4ef7-b06c-00cf7edfff61', // Visita de No Tenencia de Aves
  'a3db2a9c-f17f-4ad7-a7cd-31bba750c95f' // Visita de Cesantías
])
